import { render } from "./UserInfoHeader.vue?vue&type=template&id=e840796c&scoped=true"
import script from "./UserInfoHeader.vue?vue&type=script&lang=js"
export * from "./UserInfoHeader.vue?vue&type=script&lang=js"

import "./UserInfoHeader.vue?vue&type=style&index=0&id=e840796c&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e840796c"]])

export default __exports__